import React, {useEffect, useState} from 'react';
import {Link, useParams} from 'react-router-dom';
import AdminMenu from "./AdminMenu";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import Button from "../../components/elements/Button";
import {ADMIN_API_BASE} from "../../utils/apiConfig";
import {faAdd, faBook, faSave, faTrashCan} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import CustomSwitch from "../../components/elements/CustomSwitch";

const AdminAppUpdates = () => {
    const [appUpdates, setAppUpdates] = useState([]);
    const [error, setError] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [update, setUpdate] = useState(false);

    useEffect(() => {
        fetchUpdates();
    }, []);

    const fetchUpdates = async () => {
        try {
            const token = await getCsrfToken();
            const res = await axios.get(`${ADMIN_API_BASE}/updates`,
                {
                    headers: {
                        'csrf-token': token,
                    },
                    withCredentials: true
                }
            );
            if (res.data.success) {
                setAppUpdates(res.data.updates);
            } else {
                setError(res.data.error);
            }
        } catch (e) {
            setError(e);
        }
    };

    const handleSave = async () => {
        try {
            const token = await getCsrfToken();
            const res = await axios.post(`${ADMIN_API_BASE}/updates`,
                {mandatory: update},
                {
                    headers: {
                        'csrf-token': token,
                    },
                    withCredentials: true
                }
            );
            await fetchUpdates();
        } catch (e) {
            setError(e);
        }
    }

    const handleAddButtonClick = () => {
        setIsOpen(true);
        setUpdate(false);
    };

    const handleMandatory = (value) => {
        setUpdate(value)
    }


    const getCsrfToken = async () => {
        const response = await fetch(`${ADMIN_API_BASE}/csrf-token`, {
            method: "GET",
            credentials: "include",
        });

        const data = await response.json();
        return data.csrfToken;
    };

    return (
        <>
            <div className="flex flex-1">
                <div className="flex flex-1">
                    <div className='w-1/5'>
                        <AdminMenu path='./'/>
                    </div>
                    <div className='flex-grow w-4/5'>
                        <AdminHeader title='آپدیت‌ها'/>
                        <div className='w-full flex flex-col px-10 flex-1 my-10'>
                            <Button onClick={handleAddButtonClick}>
                                <FontAwesomeIcon icon={faAdd} className="mr-2"/>
                                <span>اضافه‌کردن نسخه‌جدید</span>
                            </Button>
                        </div>
                        <div className={`w-full items-center gap-5 p-10 ${isOpen ? 'flex' : 'hidden'}`}>
                            <CustomSwitch label='Mandatory' checked={update}
                                          onChange={(value) => handleMandatory(value)}  />
                            <Button onClick={handleSave}>
                                <FontAwesomeIcon icon={faAdd}/>
                            </Button>
                        </div>
                        <div className='flex-col w-full gap-5'>
                            {appUpdates && appUpdates.length > 0 && (
                                appUpdates.map((item, index) => {
                                    return (<div className='flex text-lg gap-10 justify-center items-center' key={index}>
                                        <p><span className='font-bold'>VERSION:</span> <span>{item.version_num}</span></p>
                                        <p><span className='font-bold'>MANDATORY:</span> <span>{item.mandatory ? 'True' : 'False'}</span></p>
                                        <p><span className='font-bold'>CREATED AT:</span> <span>{item.created_at}</span></p>
                                    </div>);
                                })
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminAppUpdates;
